/*!
 * @monogrid/vue-boost v8.0.1 Copyright (C) MONOGRID S.R.L. - All Rights Reserved - Unauthorized copying of this file, via any medium is strictly prohibited
 */
import a from "./index48.mjs";
import { resolveComponent as o, openBlock as t, createBlock as n } from "vue";
import c from "./index39.mjs";
function s(e, i, m, p, d, h) {
  const r = o("LazyImage");
  return t(), n(r, {
    ref: "lazyImage",
    "lazy-src": e.lazySrc,
    width: e.data.width,
    height: e.data.height,
    src: e.data.src
  }, null, 8, ["lazy-src", "width", "height", "src"]);
}
const y = /* @__PURE__ */ c(a, [["render", s]]);
export {
  y as default
};
